import {useAppSelector} from "../../../../redux/hooks";
import {useMatch} from "react-router-dom";
import {mySongsPageStore} from "../../../songs-router/modules/my-songs-page-store/mySongsPage.store";

export interface ISongsMobileFilterNavLogic {
  isFilterActive: boolean
  filterPageUrl: string
}

export const useSongsMobileFilterNavLogic = (): ISongsMobileFilterNavLogic => {
  // The useParams hook does not find parameters in nested routes, at least the way we're currently nesting them.
  // If we were to do it the proper way for React Router v6, the following would work.
  // const currentResultsPage = useParams().resultsPage ?? 'library;
  const isBrowseTab = !!useMatch('/songs/browse');
  const currentResultsPage = isBrowseTab ? 'browse' : 'library';
  const filterPageUrl = `/songs/${currentResultsPage}/filter`;
  const isFilterActive = useAppSelector(mySongsPageStore.isFiltering);

  return {
    isFilterActive,
    filterPageUrl,
  };
}
